import FolderSorter from '../helpers/folderSorting';
import Color from 'color';
import Marked from 'marked';
import DOMPurify from 'dompurify';

function findChildFolderByName(folders, folderName) {
  if (folders.name === folderName) {
    return folders;
  } else {
    for (const c in folders.children) {
      const found = (findChildFolderByName(folders.children[c], folderName));
      if (found) {
        return found;
      }
    }
  }
  return null;
}

function findChildFolderById(folders, folderId) {
  if (folders.id === folderId) {
    return folders;
  } else {
    for (const c in folders.children) {
      const found = (findChildFolderById(folders.children[c], folderId));
      if (found) {
        return found;
      }
    }
  }
  return null;
}

function getSortedFolders(folder, result, indent) {
  if ((folder.id === -1) || (folder.id === -2)) {
    return;
  }
  if (indent >= 0) {
    result.push({ text: '\xa0\xa0'.repeat(indent) + `${folder.dispName}`,
      value: folder.name
    });
  }
  if (Object.keys(folder.children).length > 0) {
    for (let name of FolderSorter(folder.children, folder.parent === null)) {
      getSortedFolders(folder.children[name], result, indent + 1);
    }
  }
}

export default {
  isLoggedIn(state) {
    return state.isLoggedIn;
  },
  getFolderByName: (state) => (folderName) => {
    return findChildFolderByName(state.folders, folderName);
  },
  getFolderById: (state) => (folderId) => {
    return findChildFolderById(state.folders, folderId);
  },
  getFoldersAsOptions(state) {
    let result = [];
    getSortedFolders(state.folders, result, -1);
    console.log('folders as options', result);
    return result;
  },
  favouriteFolders(state, getters) {
    if (state.settings.favouritefolders) {
      // filter to check that only existing folders are included;
      let favourites = state.settings.favouritefolders.filter(f => getters.getFolderByName(f));
      return favourites;
    } else {
      return [];
    }
  },
  selectedCalendars(state) {
    return state.settings.selectedcalendars;
  },
  calendarEventStyles(state) {
    let result = {};
    state.calendars.forEach(c => {
      const colour = Color(c.colour);
      const bgColour = colour.mix(Color('white'), 0.9);
      result[c.id] = { backgroundColor: bgColour, borderLeftColor: colour };
    });
    return result;
  },
  calendarDisplayList: (state) => (vm) => {
    const thisUser = state.username;
    return state.calendars.map(c => {
      let cal = Object.assign({}, c);
      if (c.owner !== thisUser) {
        cal.dispName = vm.$t('translation:calendars.list.sharedCalendar', { owner: c.owner, name: c.name });
      } else {
        cal.dispName = vm.$t('translation:calendars.list.calendar', { owner: c.owner, name: c.name });
      }
      return cal;
    }).sort((a, b) => {
      if ((a.owner === thisUser) && (b.owner !== thisUser)) {
        return -1;
      } else if ((a.owner !== thisUser) && (b.owner === thisUser)) {
        return 1;
      }
      return a.dispName.localeCompare(b.dispName);
    });
  },
  areImagesAllowed: (state) => (sender) => {
    const u = state.collectedAddresses[sender];
    if (u) {
      return u.allowimages;
    }
    return false;
  },
  senderEmailAddresses(state) {
    let emailaddress = state.settings.emailaddress;
    if (emailaddress === '') {
      emailaddress = state.username + '@' + state.settings.defaultdomain;
    }
    return emailaddress;
  },
  sendingSignature(state) {
    let sig;
    let sigMode = state.settings.signaturemode;
    switch (sigMode) {
      case 'markdown':
        sig = state.settings.signaturemarkdown;
        break;

      case 'html':
        sig = state.settings.signaturehtml;
        break;

      case 'text':
        sig = state.settings.signature;
        break;

      default:
        sig = state.settings.signature;
        sigMode = 'markdown';
        break;
    }

    sig = sig.trimEnd();
    if (sigMode === 'markdown') {
      if (state.settings.forceSignatureMarker) {
        if (sig.substr(0, 3) !== '-- ') {
          sig = '-- \n' + sig;
        }
      }

      Marked.setOptions({ breaks: true });
      sig = Marked(sig);
    } else if (sigMode === 'text') {
      if (state.settings.forceSignatureMarker) {
        if (sig.substr(0, 3) !== '-- ') {
          sig = '-- \n' + sig;
        }
      }

      sig = sig
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/\n/g, '<br>');
    } else if (sigMode === 'html') {
      if (state.settings.forceSignatureMarker) {
        if (sig.substr(0, 3) !== '-- ') {
          sig = '<p>-- </p>' + sig;
        }
      }
    }
    sig = DOMPurify.sanitize(sig, { FORCE_BODY: true, FORBID_TAGS: ['title'] });
    console.log('sigmode = ', state.settings.signaturemode);
    console.log('sig = ', sig);
    return sig;
  },
  totpServerName(state) {
    return state.settings.localhostname || 'localhost';
  }
};
